export default {
  title: 'Otrzymuj aktualności i oferty e-mailem',
  form: {
    marketing_subscription: {
      label: 'Otrzymuj ekskluzywne oferty, rabaty i aktualności prosto do skrzynki',
    },
  },
};
